// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + "reactPlayerPreview" + "." + "930717c7" + ".chunk.js";
};